/**
 * @deprecated Use values from `theme.core.typography.fontSize` instead.
 */
const FONT_SIZES = {
  /**
   * @deprecated Use `theme.core.typography.fontSize.xs` instead.
   */
  xxs: '10px',

  /**
   * @deprecated Use `theme.core.typography.fontSize.sm` instead.
   */
  xs: '12px',

  /**
   * @deprecated Use `theme.core.typography.fontSize.sm` instead. (13px is not supported anymore)
   */
  s: '13px',

  /**
   * @deprecated Use `theme.core.typography.fontSize.md` instead.
   */
  m: '14px',

  /**
   * @deprecated Use `theme.core.typography.fontSize.base` instead.
   */
  l: '16px',

  /**
   * @deprecated Use `theme.core.typography.fontSize.lg` instead.
   */
  xl: '18px',

  /**
   * @deprecated Use `theme.core.typography.fontSize.xl` instead. (21px is invalid and should be 20px now)
   */
  xxl: '21px',

  /**
   * @deprecated Use `theme.core.typography.fontSize.3xl` instead.
   */
  xxxl: '30px',

  /**
   * @deprecated Use `theme.core.typography.fontSize.4xl` instead.
   */
  xxxx: '40px',
} as const;

export default FONT_SIZES;
